import React from "react";
import { Loader2, Plus } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { inputClass, labelClass, btnPrimary } from "@/components/Brand";

/** New-marketer row: name, promo code, discount and commission. */
export const AffiliateForm = ({ form, setForm, busy, onSubmit }) => {
  const { t } = useI18n();

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end">
      <div>
        <label className={labelClass}>{t("marketer_name")}</label>
        <input data-testid="affiliate-name-input" className={inputClass} required value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Rizky Pratama" />
      </div>
      <div>
        <label className={labelClass}>{t("promo_code")}</label>
        <input data-testid="affiliate-code-input" className={inputClass} value={form.code}
          onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })}
          placeholder={t("promo_code_optional")} maxLength={12} />
      </div>
      <div>
        <label className={labelClass}>{t("discount_percent")}</label>
        <input data-testid="affiliate-discount-input" type="number" min="0" max="100" className={inputClass}
          value={form.discount_percent}
          onChange={(e) => setForm({ ...form, discount_percent: e.target.value })} />
      </div>
      <div>
        <label className={labelClass}>{t("commission_percent")}</label>
        <input data-testid="affiliate-commission-input" type="number" min="0" max="100" className={inputClass}
          value={form.commission_percent}
          onChange={(e) => setForm({ ...form, commission_percent: e.target.value })} />
      </div>
      <button data-testid="affiliate-submit-btn" disabled={busy} className={btnPrimary}>
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} {t("add_marketer")}
      </button>
    </form>
  );
};
